<template>
	<div class="header">
		<div class="content">
			<router-link to="/Index" class="logo"><span></span></router-link>
			<nav class="navbar" :class="{ active: open }">
				<router-link @click.native="jump" :to="item.path" :class="{ active: activeIndex == item.path }" v-for="item in meauList">{{ item.name }}</router-link>
			</nav>

			<div class="icons"><img src="@/assets/icon_meau.png" alt="" @click="meauClick" /></div>
		</div>
		<div class="block" v-show="open"></div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			activeIndex: '/Index',
			meauList: [
				{
					path: '/Index',
					name: '首页'
				},
				{
					path: '/Solution',
					name: '解决方案'
				},
				{
					path: '/ProductCenter',
					name: '产品中心'
				},
				{
					path: '/AboutUs',
					name: '关于我们'
				}
			],
			open: false
		};
	},
	// 检测路由变化
	watch: {
		$route() {
			this.setCurrentRoute();
		}
	},
	created() {
		this.setCurrentRoute();
	},
	mounted() {},
	methods: {
		jump() {
			console.log(1);
			this.open = false;
		},
		setCurrentRoute() {
			this.activeIndex = this.$route.path; // 通过他就可以监听到当前路由状态并激活当前菜单
		},
		meauClick() {
			this.open = !this.open;
		}
	}
};
</script>

<style scoped lang="less">
.header {
	width: 100%;
	background: #ffffff;
	position: sticky;
	top: 0;
	left: 0;
	right: 0;
	background-color: #ffffff;
	z-index: 1000;

	.block {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		background: rgba(0, 0, 0, 0.5);
		z-index: 1;
	}

	.content {
		height: 116px;
		padding: 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;
		z-index: 2;

		.logo span {
			display: block;
			width: 126px;
			height: 67px;
			background: url('~@/assets/icon_logo.png') no-repeat center;
			background-size: cover;
			position: absolute;
			left: 0;
			top: 24px;
		}
		.navbar {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.navbar a {
			font-size: 18px;
			padding: 35px 0;
			margin: 0 35px;
			color: #262626;
			text-align: center;
			text-decoration: inherit;
		}

		.navbar a.active {
			text-decoration: inherit;
			color: #16b7f3;
			position: relative;
		}

		.navbar a.active::after {
			content: '';
			width: 66px;
			height: 4px;
			background: #16b7f3;
			position: absolute;
			bottom: 0;
			left: 50%;
			margin-left: -33px;
		}

		.icons {
			display: none;
		}

		.icons img {
			width: 48px;
		}
	}
}

@media (max-width: 768px) {
	.header .content {
		height: 88px;
		padding: 0 30px;
		background: #fff;

		.logo span {
			display: block;
			// width: 220px;
			height: 60px;
			background: url('~@/assets/icon_logo.png') no-repeat left;
			background-size: auto 100%;
			top: 10px;
			left: 30px;
		}

		.navbar {
			position: absolute;
			top: 99%;
			left: 0;
			right: 0;
			background-color: #ffffff;
			clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
			display: block;

			a {
				font-size: 32px;
				margin: 0 50px;
				padding: 36px 0;
				border-bottom: 1px solid #dedede;
				display: block;

				&::after {
					display: none;
				}

				&:last-child {
					border: none;
				}
			}
		}

		.navbar.active {
			clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
		}

		.icons {
			display: block;
		}
	}
}
</style>
